<template>
  <v-rating v-model="params.data.rating" length="5" density="compact" size="small" readonly></v-rating>
</template>
  
<script>
export default {
    name: "RatingCell",
};
</script>